import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../../components/loader/loader";
import {
  amend_order_data,
  dataExports,
  get_Order_list,
} from "../../services/authServices";
import moment from "moment/moment";
import { Col, Form, Row } from "react-bootstrap";
import TablePagination from "../../components/pagination/tablePagination";
import CustomButton from "../../components/button/button";
import { DATA_EXPORTS } from "../../constant/api";
import axios from "axios";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;
// import '../orderDetails/orderDetails.css'

const customStyles = {
  title: {
    style: {
      fontColor: "red",
      fontWeight: "900",
    },
  },
  rows: {
    style: {
      // minHeight: '72px', // override the row height
      textCenter: "align",
    },
  },
 
  headCells: {
    style: {
      fontSize: "12px",
      fontWeight: "900",
      border: "1px solid #dee2e6",  
     
      textCenter: "align",
      textTransform: "uppercase",

     
    },
  },

  cells: {
    style: {
      
      borderRight: '1px solid #dee2e6',
     
    },
  },
};

const OrderList = () => {
  const [OrderData, setOrderData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [order_Details, setOrder_Details] = useState("");
  const [userId, setUserId] = useState("");
  const [filterDate, setFilterDate] = useState({
    fromDate: "",
    toDate: "",
  });
  const navigate = useNavigate();

  const [pageCount, setPageCount] = useState(0);
  const [pageData, setPageData] = useState(30);
  const [page, setPage] = useState(1);

  const toHoursAndMinutes = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}H:${minutes}Min`;
  };
  const handleClick = (item) => {
    navigate(`/orderDetailsList/id=${item.tmt_order_id}`);
  };
  const OnlyDateFormate = (data) => {
    return moment(data).format("DD-MM-YYYY");
  };
  const DetailedDate = (data) => {
    const d = new Date(data);
    return moment(d).format("MMMM Do YYYY, H:MM A");
  };

  // Data
  const columns = [
    {
      name: "TMT Order ID",
      selector: (row) => row?.tmt_order_id,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: "TMT User ID",
      selector: (row) => row?.tmt_userIdf,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: "Booking Date",
      selector: (row) => OnlyDateFormate(row.booking_date),
      style: {
        cursor: "pointer",
      },
    },
    {
      name: "Trip Type",
      selector: (row) => row?.trip_type,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: "Total Amount",
      selector: (row) => row?.trip_info?.sales,
      style: {
        cursor: "pointer",
      },
    },
    // {
    //   name: "Booking Type",
    //   selector: (row) => refundledun(row.trip_info.sector_details[1]?.totalPriceList?.fd?.ADULT?.rT),
    // },
    {
      name: "Booking Status",
      style: {
        cursor: "pointer",
      },
      // selector: (row) => row?.booking_status,
      cell: (row) => (
        <div
          className={row?.booking_status === "ABORTED" && "abortedCSS"}
          style={
            row?.booking_status === "SUCCESS"
              ? { color: "green", fontWeight: "600", fontSize: "12px" }
              : { color: "red", fontWeight: "600", fontSize: "10px" }
          }
        >
          {row?.booking_status}
        </div>
      ),
    },
    {
      name: "Cabin Class",
      selector: (row) => row?.cabinclass,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: "Merchant ID",
      selector: (row) => row?.tmt_merchant_id,
      style: {
        cursor: "pointer",
      },
    },

    // {
    //   name: "Merchant Order Invoice ID",
    //   selector: (row) => row?.tmt_merchant_invoice_id,
    // },
    {
      name: "Merchant Order ID",
      selector: (row) => row?.merchant_orderId,
      style: {
        cursor: "pointer",
      },
      minWidth: "140px",
    },

    // {
    //   name: "Airline Details",
    //   selector: (row) =>
    //     row.trip_info.sector_details[0]?.sI?.map((i, k) => {
    //       return (
    //         <>
    //           <div>
    //             {k + 1}
    //             {")"} <b>{i?.fD?.aI?.name}</b>({i?.fD?.aI?.code}-{i?.fD?.fN}→
    //             {i?.fD?.eT})
    //           </div>
    //           <br />
    //         </>
    //       );
    //     }),
    //   minWidth: "250px",
    // },

    // {
    //   name: "Traveller Details",
    //   selector: (row) =>
    //     row.trip_info.travellerInfo.map((i, k) => {
    //       return (
    //         <div>
    //           <Row>
    //             <Col>
    //               {k + 1}
    //               {")"} Name:{" "}
    //               <b>
    //                 {i?.ti} {i?.fN} {i?.lN}
    //               </b>
    //             </Col>
    //           </Row>
    //           <Row>
    //             <Col>
    //               Type:<b>{i?.pt}</b>
    //             </Col>
    //           </Row>
    //           <Row>
    //             <Col>
    //               Born: <b>{OnlyDateFormate(i?.dob)}</b>
    //             </Col>
    //           </Row>
    //           <br />
    //         </div>
    //       );
    //     }),
    //   minWidth: "250px",
    // },
    // {
    //   name: "Depart Segment",
    //   selector: (row) =>
    //     row.trip_info.sector_details[0]?.sI?.map((i, k) => {
    //       return (
    //         <div>
    //           <Row>
    //             <Col>
    //               {k + 1}) From:{" "}
    //               <b>
    //                 {i?.da?.city}({i?.da?.cityCode})
    //               </b>
    //             </Col>
    //           </Row>
    //           <Row>
    //             <Col>
    //               Airpot:{" "}
    //               <b>
    //                 {i?.da?.name}({i?.da?.code})
    //               </b>
    //             </Col>
    //           </Row>
    //           <Row>
    //             <Col>
    //               Country: <b>{i?.da?.country}</b>
    //             </Col>
    //           </Row>

    //           <br />
    //         </div>
    //       );
    //     }),
    //   minWidth: "350px",
    // },
    // {
    //   name: "Arrival Segment",
    //   selector: (row) =>
    //     row.trip_info.sector_details[0]?.sI?.map((i, k) => {
    //       return (
    //         <div>
    //           <Row>
    //             <Col>
    //               {k + 1}) From:{" "}
    //               <b>
    //                 {i?.aa?.city}({i?.aa?.cityCode})
    //               </b>
    //             </Col>
    //           </Row>
    //           <Row>
    //             <Col>
    //               Airpot:{" "}
    //               <b>
    //                 {i?.aa?.name}({i?.aa?.code})
    //               </b>
    //             </Col>
    //           </Row>
    //           <Row>
    //             <Col>
    //               Country: <b>{i?.aa?.country}</b>
    //             </Col>
    //           </Row>

    //           <br />
    //         </div>
    //       );
    //     }),
    //   minWidth: "350px",
    // },
    // {
    //   name: "Time Duration",
    //   selector: (row) =>
    //     row.trip_info.sector_details[0]?.sI?.map((i, k) => {
    //       return (
    //         <div>
    //           <Row>
    //             <Col>
    //               Depart Time: <b>{DetailedDate(i?.dt)}</b>
    //             </Col>
    //           </Row>
    //           <Row>
    //             <Col>
    //               Layover Time:{" "}
    //               <b>{!i?.cT ? "N.A." : toHoursAndMinutes(i?.cT)}</b>
    //             </Col>
    //           </Row>
    //           <Row>
    //             <Col>
    //               Arrival Time: <b>{DetailedDate(i?.at)}</b>
    //             </Col>
    //           </Row>

    //           <br />
    //         </div>
    //       );
    //     }),
    //   minWidth: "285px",
    // },
    // {
    //   name: "Travel Duration",
    //   selector: (row) =>
    //     row.trip_info.sector_details[0]?.sI?.map((i, k) => {
    //       return (
    //         <div>
    //           <Row>
    //             <Col>
    //               <b>
    //                 {!i?.duration
    //                   ? "Something went wrong"
    //                   : toHoursAndMinutes(i?.duration)}
    //               </b>
    //             </Col>
    //           </Row>
    //           <br />
    //         </div>
    //       );
    //     }),
    //   minWidth: "150px",
    // },
    {
      name: "Base Fare",
      selector: (row) =>
        "₹" + row?.trip_info?.totalPriceInfo?.totalFareDetail?.fC?.BF,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: "Net Fare",
      selector: (row) =>
        "₹" + row?.trip_info?.totalPriceInfo?.totalFareDetail?.fC?.NF,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: "Tax And Fare",
      selector: (row) =>
        "₹" + row?.trip_info?.totalPriceInfo?.totalFareDetail?.fC?.TAF,
      style: {
        cursor: "pointer",
      },
    },
    {
      name: "Total Fare",
      selector: (row) =>
        "₹" + row?.trip_info?.totalPriceInfo?.totalFareDetail?.fC?.TF,
      style: {
        cursor: "pointer",
      },
    },
    // {
    //   name: "TAX AND FARES",
    //   selector: (row) => {
    //     return row?.trip_info?.totalPriceInfo?.totalFareDetail?.afC?.TAF;
    //     // let keys = obj && Object.keys(obj);
    //     // let values = obj && Object.values(obj);
    //     // for (var i = 0; i < (keys ? keys?.length : 0); i++) {
    //     //   return `${keys[i]} : ${values[i]}`;
    //     // }
    //   },
    //   cell: (row, index, column, id) => {
    //     let obj = row?.trip_info?.totalPriceInfo?.totalFareDetail?.afC?.TAF;
    //     let keys = obj && Object.keys(obj);
    //     let values = obj && Object.values(obj);
    //     keys &&
    //       keys.length > 0 &&
    //       keys.map((data, index) => {
    //         return <li>{data + ":" + values[index]}</li>;
    //       });
    //   },
    // },
  ];
  const getDetails = async (page, per_page) => {
    setLoading(true);
    // let pagination = { page, limit: pageData };
    let params = {
      request: "GETDATA",
    };
    let data = { page: page, limit: per_page };
    try {
      const res = await get_Order_list(params, data);
      setOrderData(res?.data?.Data.getOrder);
      setPageCount(res?.data?.Data.orderCount);
      setTotalRows(res?.data?.Data.orderCount);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  // pagination logic...

  useEffect(() => {
    getDetails(1, perPage);
  }, [perPage]);

  const handlePageChange = (page) => {
    getDetails(page, perPage);
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
  };
  useEffect(() => {
    const pagedatacount = Math.ceil(pageCount / pageData);
    setPageCount(pagedatacount);
  }, [OrderData]);

  const handleRowSize = (e) => {
    const { innerHTML } = e.target;
    setPageData(innerHTML);
    console.log("row per page size", innerHTML);
  };

  const handleOrderData = (e) => {
    const { name, value } = e.target;
    console.log("selected value", value);
    setOrder_Details(value);
  };
  

  const handleDataExport = async () => {
    let params = {};

    if (order_Details === "All Date") {
      params = { FilterBy: order_Details };
    } else if (order_Details === "Client") {
      params = { FilterBy: order_Details, userid: userId };
    } else if (order_Details === "Booking Date") {
      params = {
        FilterBy: order_Details,
        to: filterDate.toDate,
        from: filterDate.fromDate,
      };
      console.log("filter date here for ", filterDate);
    } else {
    }
    const response = await axios.post(DATA_EXPORTS, params, {
      responseType: "blob", // Set responseType to 'blob' to handle binary data
    });

    console.log("Response pdf", response);
    const blob = new Blob([response.data], { type: "application/xlsx" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${order_Details}.xlsx`; // Set the desired file name
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };
  // const disabledDate = (current) => {
  //   return moment().add(-1, "days") >= current;
  // };

  const handeldate = (date) => {
    setFilterDate({
      ...filterDate,
      fromDate: moment(date[0]?.$d).format("YYYY-MM-DD"),
      toDate: moment(date[1]?.$d).format("YYYY-MM-DD"),
    });
  };
  console.log("order detail here", order_Details);
  return (
    <div>
      <Row className="my-3">
        <Col lg={3} className="d-flex align-items-center">
          <Form.Select
            onChange={handleOrderData}
            aria-label="Default select example"
          >
            <option>Filter Data</option>
            <option value="All Date">All Date</option>
            <option value="Client">Client</option>
            <option value="Booking Date">Booking Date</option>
          </Form.Select>
        </Col>
        <Col className="d-flex align-items-center">
          {order_Details === "Booking Date" && (
            <RangePicker
              allowClear={true}
              onChange={(val) => {
                handeldate(val);
              }}
              format={["DD-MM-YYYY", "DD-MM-YYYY"]}
              placeholder={["fromDate", "toDate"]}
              // disabledDate={disabledDate}
            />
          )}
          {order_Details === "Client" && (
            <Form>
              <Form.Control
                type="text"
                //  autoComplete="off"
                autoComplete="new-password"
                name="myInput"
                placeholder="Enter UserIdf"
                //  value={userId}
                onChange={(e) => setUserId(e.target.value)}
              />
            </Form>
          )}
        </Col>
        <Col>
          <CustomButton
            disabled={order_Details.length === 0}
            buttonText={"Export"}
            onClick={handleDataExport}
          />
        </Col>
      </Row>
      {/* <CustomLoader isLoading={isLoading} /> */}

      <DataTable
        columns={columns}
        data={OrderData}
        fixedHeader
  fixedHeaderScrollHeight="500px"
        responsive
        // dense
        progressPending={isLoading}
        customStyles={customStyles}
        onRowClicked={(data) => handleClick(data)}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
      />
    </div>
  );
};

export default OrderList;
